import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"10px","text-align":"left"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { key: 5 }
const _hoisted_8 = ["src", "onClick"]
const _hoisted_9 = { style: {"padding":"20px"} }
const _hoisted_10 = {
  key: 0,
  class: "easy-wrap"
}
const _hoisted_11 = ["src"]

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allAdvertise, addAdvertise,reviseAdvertiseState,delAdvertise} from '../../api'
  import { getToken } from '@/utils/auth'
  import {getUrl} from '../../api/comfig'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const  httpUrl=getUrl();

  const search = reactive({
    type: "0",
    state: "0",
  })
 

  
const headers= reactive({
  'token': getToken()
})
  
  const loading = ref(false);
  const dataSource = ref([]);
  const selectedKeys = ref([]);
  const page = reactive({ current: 1, limit: 10, total: 0 });
  const columns = ref([ 
    { title: "图片", key: "thumbnail", align: "center" , customSlot: "thumbnail"},
    { title: "标题", key: "title", align: "center" },
    { title: "跳转地址", key: "jumpURL", align: "center" },
    { title: "类型", key: "showPage", align: "center", customSlot: "showPage" },
    { title: "状态", key: "state", align: "center", customSlot: "state" }, 
    { title: "到期时间", key: "expTime", align: "center" },
    { title: "时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
  ]);
  
  const getAllAdvertise = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit, "type": search.type,"state": search.state };
    allAdvertise(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllAdvertise();
  
  
  const change = (page: any) => {
    getAllAdvertise();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  

//查看图片

const signleImg = (imgur: any) => {
  layer.photos({
    imgList: [{ src: imgur }]
  })
}
  //查询接口
  const searchUser = () => {
    page.current=1;
    getAllAdvertise();
  }
   
  //修改类型接口
  const changeState = (row: any) => { 
  var data = { "key": row.state, "id":row.id };
  reviseAdvertiseState(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
      getAllAdvertise();
      layer.msg("操作成功", { time: 1000, icon: 1 });
    }
  })
}
  
  //上传文件回调方法
  const getUploadFile2 = (res: any) => {
  res = JSON.parse(res.data);
  if (res.code == 0) {
    advertise.thumbnail = res.data.src;
 
    layer.msg("上传成功", { time: 1000, icon: 1 })
  } else {
    layer.msg("上传异常", { icon: 3, time: 1000 })
  }

}


  
  const advertise = reactive({
    id:0,
    title: "",
    thumbnail: "",
    jumpURL: "", 
    showPage: "", 
    state: "", 
    expTime: "", 
  })
  
  
  const deleAdvertise = (row: any) => {
       var data={'id':row.id} 
    delAdvertise(JSON.stringify(data)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllAdvertise(); 
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
   
  }
  
  const layFormRef11 = ref();
  
  const visible11 = ref(false);
  
  const isDisabled = ref(false);

  const updateAdvertise= (row: any) => {

    advertise.id = row.id;
    advertise.title =row.title;
    advertise.thumbnail = row.thumbnail;
    advertise.jumpURL =row.jumpURL;
    advertise.showPage =row.showPage;
    advertise.state = row.state;
    advertise.expTime = row.expTime;
  
    isDisabled.value = false;
    visible11.value = !visible11.value;
  }
  
  const changeVisible11 = () => {
    advertise.id = 0;
    advertise.title = "";
    advertise.thumbnail = "";
    advertise.jumpURL = "";
    advertise.showPage = "";
    advertise.state = "";
    advertise.expTime = "";
  
    isDisabled.value = false;
    visible11.value = !visible11.value;
  }
  
  const action11 = ref([
    {
      text: "确认",
      callback: () => {
        addAdvertise(JSON.stringify(advertise)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllAdvertise();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        visible11.value = false;
  
  
      }
    }
  ])
  
  
  
return (_ctx: any,_cache: any) => {
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_switch = _resolveComponent("lay-switch")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_upload = _resolveComponent("lay-upload")!
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_date_picker = _resolveComponent("lay-date-picker")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_form, {
                  model: search,
                  style: {"text-align":"start"},
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "展示页面",
                      prop: "type",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_select, {
                          modelValue: search.type,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.type) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_select_option, {
                              value: "0",
                              label: "全部"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "1",
                              label: "启动页面"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "2",
                              label: "首页轮播图"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "3",
                              label: "视频列表"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "4",
                              label: "视频播放页面"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "5",
                              label: "凤楼列表"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "6",
                              label: "凤楼详情"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, {
                      label: "状态",
                      prop: "state",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_select, {
                          modelValue: search.state,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.state) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_select_option, {
                              value: "0",
                              label: "全部"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "1",
                              label: "正常"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "2",
                              label: "下架"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, { mode: "inline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_button, {
                          type: "primary",
                          size: "sm",
                          onClick: searchUser
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_lay_button, {
                    size: "sm",
                    onClick: changeVisible11,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[2] || (_cache[2] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  showPage: _withCtx(({ row }) => [
                    (row.showPage==1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "启动页面"))
                      : (row.showPage==2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "首页轮播图"))
                        : (row.showPage==3)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "视频列表"))
                          : (row.showPage==4)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "视频播放页面"))
                            : (row.showPage==5)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "凤楼列表"))
                              : (row.showPage==6)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "凤楼详情"))
                                : _createCommentVNode("", true)
                  ]),
                  state: _withCtx(({ row }) => [
                    _createVNode(_component_lay_switch, {
                      "model-value": row.state == 0 ? true : false,
                      onChange: ($event: any) => (changeState(row)),
                      "onswitch-text": "正常",
                      "unswitch-text": "下架"
                    }, null, 8, ["model-value", "onChange"])
                  ]),
                  thumbnail: _withCtx(({ row }) => [
                    _createElementVNode("img", {
                      src: row.thumbnail,
                      onClick: ($event: any) => (signleImg(row.thumbnail)),
                      style: {"width":"62.9px","height":"80px"}
                    }, null, 8, _hoisted_8)
                  ]),
                  operator: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (updateAdvertise(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "danger",
                      onClick: ($event: any) => (deleAdvertise(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['400px', '480px'],
      btn: action11.value,
      title: "添加/修改"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_lay_form, {
            model: advertise,
            ref_key: "layFormRef11",
            ref: layFormRef11
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "图片",
                prop: "title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_upload, {
                    onDone: getUploadFile2,
                    disabledPreview: false,
                    multiple: false,
                    acceptMime: "image/*",
                    url: _unref(httpUrl)+'/common/imgUpload/advertise',
                    field: "file",
                    headers: headers
                  }, {
                    preview: _withCtx(() => [
                      (advertise.thumbnail!='')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("img", {
                              src: advertise.thumbnail,
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (signleImg(advertise.thumbnail))),
                              style: {"width":"80.9px","height":"80.2px"}
                            }, null, 8, _hoisted_11)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["url", "headers"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "标题",
                prop: "title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: advertise.title,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((advertise.title) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "跳转地址",
                prop: "jumpURL"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: advertise.jumpURL,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((advertise.jumpURL) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "到期时间",
                prop: "expTime"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_date_picker, {
                    type: "datetime",
                    modelValue: advertise.expTime,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((advertise.expTime) = $event)),
                    placeholder: "请选择广告到期时间"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "展示页面",
                prop: "showPage",
                mode: "inline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_select, {
                    modelValue: advertise.showPage,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((advertise.showPage) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select_option, {
                        value: "1",
                        label: "启动页面"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: "2",
                        label: "首页轮播图"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: "3",
                        label: "视频列表"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: "4",
                        label: "视频播放页面"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: "5",
                        label: "凤楼列表"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: "6",
                        label: "凤楼详情"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})